export const SITE_NAME = {
  CHINESE_BROTHERS: "chinese-brothers",
  QUBICTRON: "qubictron",
};
